import { useMemo } from 'react'
import { NumericFormat, NumberFormatValues, SourceInfo } from 'react-number-format'

import { EuiFieldNumber } from '@equipmentshare/ds2'
import { CurrencyFieldProps } from './types'

export default function CurrencyFieldEui( {
	onRawChange,
	disabled,
	isInvalid,
	value,
	intlNumberFormatOptions,
	defaultValue,
	type,
	// MUI-only (sc-548648 floating labels): FormRow's EUI branch delegates to
	// real `EuiFormRow`, which renders its own label and never injects these —
	// destructured only so they don't leak into the `...props` spread below.
	/* eslint-disable @typescript-eslint/no-unused-vars */
	label,
	error,
	helperText,
	/* eslint-enable @typescript-eslint/no-unused-vars */
	...props
}: CurrencyFieldProps ) {
	const onValueChange = ( values: NumberFormatValues, sourceInfo: SourceInfo ) => onRawChange( values.value, sourceInfo.source === 'event' )

	const formattedValue = useMemo( () => (
		value ? new Intl.NumberFormat( 'en-US', {
			style: 'decimal',
			currency: 'USD',
			maximumFractionDigits: 4,
			minimumFractionDigits: 2,
			...intlNumberFormatOptions
		} ).format( parseFloat( value ) ) : ''
	), [ value ] )

	return (
		<NumericFormat
			customInput={EuiFieldNumber}
			thousandSeparator
			valueIsNumericString
			decimalScale={4}
			fixedDecimalScale={false}
			prefix="$"
			onValueChange={onValueChange}
			disabled={disabled}
			isInvalid={isInvalid}
			value={formattedValue}
			allowNegative={false}
			defaultValue={defaultValue as string | number | undefined}
			type={( type === 'text' || type === 'tel' || type === 'password' ) ? type as ( 'text' | 'tel' | 'password' ) : 'text'}
			{...props}
		/>
	)
}
